import { Button } from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)`
    height: 50px;
`;
